import { render, staticRenderFns } from "./AppVehicleNew.vue?vue&type=template&id=c43afe9a&scoped=true&"
import script from "./AppVehicleNew.vue?vue&type=script&lang=js&"
export * from "./AppVehicleNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43afe9a",
  null
  
)

export default component.exports